import axios from 'axios'
import store from '@/store/store'
import {Environment} from "@/environment/environment";

export default function () {
    axios.interceptors.request.use(request => {
        if (store.getters['identity/isAuthenticated']) {
            request.headers.common['x-auth-token'] = store.getters['identity/getApiToken']
        }

        if (Environment.isDevelopment()) {
            request.params = {...request.params, XDEBUG_SESSION_START: "PHPSTORM"};
        }

        return request
    }, error => {
        return Promise.reject(error)
    })
    axios.interceptors.response.use(response => {
        const apiTokenExpiresAt = response.headers['X-AUTH-TOKEN-EXPIRES-AT']
        if (apiTokenExpiresAt) {
            store.commit('identity/setApiTokenExpiresAt', apiTokenExpiresAt)
        }
        return response
    }, error => {
        return Promise.reject(error)
    })
}
